/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
import {
  MONTH_PICKER, NUMBER_INPUT, PROCEDURES, TEXT_INPUT, TREATMENT_HISTORY, COMPOSITE, SIMPLE_COMPOSITE, OPTIONS_FROM_SERVER,
} from 'modules/questionnaire/questionTypes';
import formatMonthPickerValue from './formatMonthPickerValue';
import { tryInferOptions } from './tryInferOptions';

// it works for all types except TRIPLE_QUESTION_DROP_DOWN type
export const conditionProfileValueToFormValue = ({
  conditionProfileValue,
  question,
  optionsFromServer,
  condition,
}) => {
  const { type: questionType } = question;
  switch (questionType) {
    case MONTH_PICKER:
      return formatMonthPickerValue(conditionProfileValue, true);
    case COMPOSITE:
    case SIMPLE_COMPOSITE:
    case PROCEDURES:
    case TREATMENT_HISTORY:
      const treatmentsAdditionalFields = ['taking_state', 'updated_taking_state_date', 'survey_answered', 'date_of_adding'];
      const { subQuestions } = question;
      return (conditionProfileValue ?? []).map((subQuestionConditionProfileValue) => {
        const subQuestionFormValue = {};
        subQuestions.forEach((subQuestion) => {
          subQuestionFormValue[subQuestion.id] = conditionProfileValueToFormValue({
            conditionProfileValue: subQuestionConditionProfileValue[subQuestion.id],
            question: subQuestion,
            optionsFromServer,
            condition,
          });
        });
        if (questionType !== PROCEDURES) {
          treatmentsAdditionalFields.forEach((additionalField) => {
            subQuestionFormValue[additionalField] = subQuestionConditionProfileValue[additionalField];
          });
        }
        return subQuestionFormValue;
      });
    case NUMBER_INPUT:
      return typeof conditionProfileValue === 'number' ? String(conditionProfileValue) : conditionProfileValue;
    case TEXT_INPUT:
      return conditionProfileValue;
    default: {
      if (conditionProfileValue === null) {
        return null;
      }

      const options = tryInferOptions(question, optionsFromServer);
      if (question.type === OPTIONS_FROM_SERVER && typeof conditionProfileValue === 'string') {
        conditionProfileValue = conditionProfileValue.split(',');
      }
      if (Array.isArray(conditionProfileValue)) {
        return options.filter((option) => conditionProfileValue.includes(option.value));
      }
      return options.find((option) => String(option.value) === String(conditionProfileValue));
    }
  }
};
